export default {
  about_badge: '// Chi siamo',
  about_title1: 'RHEINMETALL AG —',
  about_title2: 'LEADER DELLA DIFESA',
  about_title3: 'EUROPEA',
  about_desc1: 'Fondata nel 1889, Rheinmetall AG è il più grande conglomerato della difesa tedesco e uno dei principali produttori mondiali di equipaggiamento militare e munizioni. Sede a Düsseldorf, Germania.',
  about_desc2: 'In un contesto di forte crescita dei budget della difesa NATO ed europei, Rheinmetall registra risultati finanziari record. Il portafoglio ordini ha superato <strong>€50 miliardi</strong> — capacità produttiva garantita fino al 2030 e rendimenti stabili per gli investitori.',
  about_tags: 'Veicoli corazzati,Artiglieria,Munizioni,Elettronica,Cybersicurezza',
  about_img_caption: 'Portafoglio ordini fino al 2030',
  about_stat1: 'Fondata',
  about_stat2: 'Fatturato 2024',
  about_stat3: 'Dipendenti',
  about_stat4: 'Paesi partner',
  weapons_badge: '// Armamenti prodotti',
  weapons_title1: 'ARMAMENTI',
  weapons_title2: 'DI NUOVA GENERAZIONE',
  weapons_subtitle: 'Ciclo produttivo completo dalle munizioni ai veicoli corazzati. Forniture in 50+ paesi. Ogni contratto è il tuo profitto.',
  weapons_specs_label: 'Specifiche',
  weapons_hide: 'Nascondi',
  weapons_show: 'Specifiche',
  w1_title: 'Carri armati da combattimento', w1_desc: 'Il miglior carro armato da combattimento al mondo. Leopard 2A8 è dotato di protezione attiva Trophy, sistema di controllo del fuoco e cannone Rh-120 da 120mm.', w1_tag: 'Corazzati', w1_rev: '€8.2 mld ordini',
  w2_title: 'Obice semovente', w2_desc: "L'obice semovente più preciso al mondo. Gittata fino a 67 km con proiettili guidati. Utilizzato da Germania, Paesi Bassi, Grecia, Italia e Ucraina.", w2_tag: 'Artiglieria', w2_rev: '€3.5 mld ordini',
  w3_title: 'Veicolo da combattimento fanteria', w3_desc: 'IFV di nuova generazione con architettura modulare. Armato con cannone automatico Wotan da 35mm e missili anticarro Spike LR2.', w3_tag: 'IFV', w3_rev: '€5.1 mld ordini',
  w4_title: 'Sistema di difesa aerea', w4_desc: 'Sistema di difesa aerea rivoluzionario contro droni, elicotteri e aerei a bassa quota. Cannone da 30mm a 1200 colpi/min.', w4_tag: 'Difesa aerea', w4_rev: '€2.8 mld ordini',
  w5_title: 'Munizioni 155mm', w5_desc: "Rheinmetall — il più grande produttore europeo di munizioni per artiglieria. Produzione di proiettili 155mm aumentata di 8 volte.", w5_tag: 'Munizioni', w5_rev: '€4.7 mld ordini',
  w6_title: 'Carro AA Gepard', w6_desc: 'Leggendario cannone semovente antiaereo con due cannoni da 35mm. Ha dimostrato la sua efficacia contro droni e missili da crociera in condizioni di combattimento reali.', w6_tag: 'SPAAG', w6_rev: '€1.9 mld ordini',
  conflicts_badge: '// Zone di conflitto',
  conflicts_title1: 'RUOLO CRITICO NELLA',
  conflicts_title2: 'SICUREZZA GLOBALE',
  conflicts_subtitle: 'Rheinmetall fornisce equipaggiamento in zone calde e di conflitto. Ogni colpo è il tuo reddito. La guerra è un business e ti invitiamo a farne parte.',
  conflicts_deliveries: 'Forniture',
  conflicts_hide: 'Nascondi',
  conflicts_more: 'Dettagli',
  conflicts_why_label: 'Perché è vantaggioso',
  conflicts_why_title: 'LA GUERRA È CRESCITA AZIONARIA',
  conflicts_why_desc: 'I budget della difesa NATO sono cresciuti del <strong>+40% in 2 anni</strong>. La Germania ha aumentato la spesa militare a €100 mld. La Polonia spende il 4% del PIL per la difesa.',
  stat_stocks: 'Crescita azionaria in 3 anni',
  stat_backlog: 'Portafoglio ordini',
  stat_ammo: 'Crescita produzione munizioni',
  c1_region: 'Ucraina', c1_status: 'Attivo', c1_desc: 'Il più grande acquirente di equipaggiamento Rheinmetall. Centinaia di unità Leopard 2, Marder, Gepard consegnate. Aperta una fabbrica congiunta di veicoli corazzati in Ucraina.',
  c2_region: 'Polonia', c2_status: 'Contratto firmato', c2_desc: 'La Polonia sta realizzando il più grande programma di riarmo nella storia del paese. Ordinati 800 carri K2 con torrette Rheinmetall, 500 IFV Lynx KF41.',
  c3_region: 'Germania', c3_status: 'A lungo termine', c3_desc: 'La Bundeswehr sta conducendo una modernizzazione su larga scala. Ordinati 18 PzH 2000, 123 Leopard 2A8, 143 Lynx KF41. Budget difesa cresciuto a €100 mld.',
  c4_region: 'Ungheria', c4_status: 'Produzione', c4_desc: "L'Ungheria sta costruendo una fabbrica Rheinmetall sul suo territorio. Ordinati 218 Lynx KF41 — il più grande contratto IFV nella storia europea.",
  c5_region: 'Australia', c5_status: 'Nuovo contratto', c5_desc: "L'Australia ha scelto il Lynx KF41 per sostituire gli M113 obsoleti. Contratto per 450 veicoli con produzione in Australia.",
  c6_region: 'Romania', c6_status: 'Negoziati', c6_desc: 'La Romania prevede di acquistare 300 Lynx KF41 e 54 PzH 2000. Il paese confina con l\'Ucraina e sta attivamente costruendo capacità militare con il supporto NATO.',
  calc_badge: '// Calcolatore di profitto',
  calc_title1: 'CALCOLA',
  calc_title2: 'IL TUO PROFITTO',
  calc_subtitle: 'Sistema di rendimento trasparente senza commissioni nascoste. Tutte le operazioni in 3 giorni.',
  calc_plan1: 'Starter',
  calc_plan2: 'Ottimale',
  calc_plan3: 'Premium',
  calc_popular: 'Popolare',
  calc_per_year: '%',
  calc_custom_label: 'Importo personalizzato (€)',
  calc_custom_placeholder: 'Min. €',
  calc_period_label: 'Durata operazione: 3 giorni',
  calc_period_months: '',
  calc_profit_label: 'Il tuo profitto in 3 giorni',
  calc_profit_months: '',
  calc_total_label: 'Importo totale: ',
  calc_invested: 'Investito',
  calc_rate: 'Tasso',
  calc_per_yr: '%',
  calc_cta: 'Apri conto di investimento',
  calc_feat1_title: 'Assicurazione depositi', calc_feat1_desc: 'I tuoi fondi sono protetti dal sistema europeo di assicurazione dei depositi',
  calc_feat2_title: 'Pagamenti trimestrali', calc_feat2_desc: 'Ricevi profitti ogni 3 mesi sul tuo conto',
  calc_feat3_title: 'Protezione legale', calc_feat3_desc: 'Contratto secondo il diritto tedesco, autenticato da notaio',
  contact_badge: '// Contatti',
  contact_title1: 'INIZIA',
  contact_title2: 'A INVESTIRE OGGI',
  contact_subtitle: 'Lascia una richiesta e il nostro manager ti contatterà entro 24 ore per aprire un conto di investimento.',
  contact_why_title: 'Perché sceglierci',
  contact_r1_title: 'Broker autorizzato', contact_r1_desc: 'Attività regolamentata da BaFin (Germania) e FCA (Regno Unito)',
  contact_r2_title: 'Sicurezza dei fondi', contact_r2_desc: 'Fondi detenuti in conti segregati presso Deutsche Bank',
  contact_r3_title: 'Manager personale', contact_r3_desc: 'Supporto individuale per tutta la durata dell\'investimento',
  contact_r4_title: 'Avvio rapido', contact_r4_desc: 'Conto aperto in 24 ore, primi pagamenti dopo 3 mesi',
  contact_address_label: 'Indirizzo',
  contact_form_title: 'Richiesta di investimento',
  contact_name_label: 'Il tuo nome *',
  contact_name_placeholder: 'Mario Rossi',
  contact_email_label: 'Email *',
  contact_phone_label: 'Telefono',
  contact_phone_placeholder: '+39 999 000 0000',
  contact_amount_label: 'Importo investimento',
  contact_amount_placeholder: 'Scegli un piano',
  contact_amount_opt1: '€3.000 — 24%',
  contact_amount_opt2: '€5.000 — 29%',
  contact_amount_opt3: '€10.000 — 37%',
  contact_amount_opt4: 'Importo personalizzato',
  contact_msg_label: 'Messaggio',
  contact_msg_placeholder: 'Le tue domande o richieste...',
  contact_submit: 'Invia richiesta',
  contact_sending: 'Invio...',
  contact_success: 'Richiesta inviata! Ti contatteremo entro 24 ore.',
  contact_error: 'Errore di invio. Riprova o contattaci direttamente.',
  contact_privacy: 'Cliccando il pulsante, accetti la politica sulla privacy',
  footer_desc: 'Portale di investimento Rheinmetall AG. Investi nel leader dell\'industria della difesa europea.',
  footer_company: 'Azienda',
  footer_investors: 'Investitori',
  footer_products: 'Prodotti',
  footer_about: 'Chi siamo',
  footer_history: 'Storia',
  footer_production: 'Produzione',
  footer_news: 'Notizie',
  footer_plans: 'Piani',
  footer_calculator: 'Calcolatore',
  footer_docs: 'Documenti',
  footer_faq: 'FAQ',
  footer_armor: 'Veicoli corazzati',
  footer_artillery: 'Artiglieria',
  footer_ammo: 'Munizioni',
  footer_air: 'Difesa aerea',
  footer_rights: '© 2025 Rheinmetall Investment Portal. Tutti i diritti riservati.',
  footer_privacy: 'Informativa sulla privacy',
  footer_terms: 'Termini di utilizzo',
  footer_disclaimer: "L'investimento comporta rischi. Le performance passate non garantiscono rendimenti futuri. Questo sito è a scopo informativo e non costituisce un'offerta pubblica.",
  toast_earned: 'ha guadagnato sul contratto',
  toast_period: 'in 3 giorni',

  // Navigation
  nav: {
    about: 'Chi siamo',
    weapons: 'Armamenti',
    conflicts: 'Conflitti',
    calculator: 'Calcolatore',
    contact: 'Contatti',
  },

  // Hero Section
  hero: {
    badge: 'Aperto agli investitori',
    title1: 'INVESTIMENTI',
    title2: 'NEL FUTURO',
    title3: 'DELLA DIFESA',
    description: 'Rheinmetall AG — il più grande conglomerato della difesa europea. Investi da €3.000 e ottieni fino al {{return}} in 3 giorni.',
    stat1: 'Rendimenti fino al 37% in 3 giorni',
    stat2: 'Contratti per €50+ miliardi fino al 2030',
    stat3: 'Crescita azionaria +280% in 3 anni',
    cta1: 'Calcola i rendimenti',
    cta2: 'Scopri di più',
    scroll: 'Scorri giù',
    turretLabel: 'Leopard 2A7+',
    turretHint: 'Torretta · clicca per sparare',
  },

  // About Section
  about: {
    label: 'Chi siamo',
    title: 'RHEINMETALL AG',
    subtitle: 'Leader europeo della difesa',
    description: 'Conglomerato industriale tedesco, leader mondiale nella produzione di veicoli corazzati e sistemi d\'artiglieria. Dall\'inizio della guerra in Ucraina, l\'azienda ha aumentato la produzione del 400%.',
    stats: {
      founded: 'Fondata',
      employees: 'Dipendenti',
      revenue: 'Fatturato',
      contracts: 'Ordini',
    },
  },

  // Weapons Section
  weapons: {
    label: 'Equipaggiamento militare',
    title: 'SISTEMI DI COMBATTIMENTO',
    subtitle: 'Veicoli corazzati moderni e artiglieria che costituiscono la spina dorsale delle forze NATO',
    items: {
      leopard: {
        name: 'Leopard 2A7+',
        desc: 'Carro armato da combattimento — il fiore all\'occhiello delle forze corazzate europee',
      },
      lynx: {
        name: 'Lynx KF41',
        desc: 'Veicolo da combattimento fanteria di nuova generazione',
      },
      puma: {
        name: 'PUMA',
        desc: 'Veicolo da combattimento fanteria pesante',
      },
      panzerhaubitze: {
        name: 'Panzerhaubitze 2000',
        desc: 'Obice semovente con gittata di 40 km',
      },
      fuchs: {
        name: 'Fuchs',
        desc: 'Trasporto truppe corazzato',
      },
      boxer: {
        name: 'Boxer',
        desc: 'Veicolo corazzato modulare',
      },
    },
  },

  // Conflicts Section
  conflicts: {
    label: 'Geopolitica',
    title: 'ZONE DI CONFLITTO',
    subtitle: 'Conflitti militari attuali che stimolano la crescita dell\'industria della difesa',
    ukraine: {
      title: 'Guerra in Ucraina',
      description: 'Dal 2022, Rheinmetall ha fornito oltre 200 carri armati Leopard e stabilito produzione locale. Contratti per €8,5 miliardi.',
    },
    middleEast: {
      title: 'Medio Oriente',
      description: 'Fornitura di sistemi di difesa aerea e veicoli corazzati a Qatar, EAU e Arabia Saudita. Contratti per €12 miliardi.',
    },
    baltic: {
      title: 'Regione baltica',
      description: 'Programma di rafforzamento NATO. Nuovi impianti produttivi in Lituania e Romania. Investimenti di €2,5 miliardi.',
    },
  },

  // Calculator Section
  calculator: {
    label: 'Calcolatore di investimenti',
    title: 'CALCOLA I TUOI RENDIMENTI',
    subtitle: 'Calcola i potenziali rendimenti dall\'investimento nelle azioni Rheinmetall AG',
    amount: 'Importo dell\'investimento',
    period: 'Periodo di investimento',
    years: '{{years}} anni',
    result: 'Rendimenti previsti',
    total: 'Importo totale',
    profit: 'Profitto netto',
    cta: 'Inizia a investire',
  },

  // Contact Section
  contact: {
    label: 'Contattaci',
    title: 'CONTATTACI',
    subtitle: 'I nostri consulenti di investimento sono pronti a rispondere alle tue domande',
    form: {
      name: 'Il tuo nome',
      email: 'Email',
      phone: 'Telefono',
      amount: 'Importo dell\'investimento',
      message: 'Messaggio',
      submit: 'Invia richiesta',
      success: 'Grazie! Ti contatteremo presto.',
    },
  },

  // Testimonials
  testimonials: {
    badge: '// Recensioni investitori',
    title1: 'COSA DICONO I NOSTRI',
    title2: 'INVESTITORI',
    subtitle: 'Risultati reali da investitori reali in tutta Europa. Senza volti — solo numeri.',
    from: 'da',
    stat1: 'Investitori attivi',
    stat2: 'Totale pagato',
    stat3: 'Rendimento max',
    stat4: 'Paesi',
    t1: {
      name: 'M. Krause',
      role: 'Investitore privato · Francoforte',
      text: 'All\'inizio ero scettico — gli investimenti nella difesa mi sembravano troppo di nicchia. Ma dopo la prima operazione chiusa in 3 giorni con un rendimento del 37%, ho raddoppiato la posizione. Rheinmetall non è solo un\'azienda, è una macchina che stampa denaro in tempo di guerra.',
    },
    t2: {
      name: 'I. Dimitrov',
      role: 'Imprenditore · Sofia',
      text: 'Ho provato molte piattaforme — crypto, forex, immobiliare. Niente si avvicina alla stabilità qui. Tre operazioni, tre vittorie. Il manager ha spiegato tutto chiaramente, il contratto è secondo il diritto tedesco. Dormo tranquillo.',
    },
    t3: {
      name: 'P. Wiśniewski',
      role: 'Ingegnere · Varsavia',
      text: 'La Polonia si sta riarming a ritmo record — ho deciso di trarne profitto. Ho investito €12.000 e ho ricevuto €16.440 in 3 giorni. Ora lo dico a tutti i colleghi. Questo è l\'investimento più logico del nostro tempo.',
    },
    t4: {
      name: 'L. Russo',
      role: 'Titolare d\'azienda · Milano',
      text: 'In Italia diciamo: investi dove scorrono i soldi. E i soldi ora scorrono nella difesa. Ho messo €20.000 e ho ricevuto €27.400. Il processo è stato fluido, trasparente, professionale. Consiglio vivamente.',
    },
    t5: {
      name: 'E. Hansen',
      role: 'Analista finanziario · Oslo',
      text: 'Come analista seguo quotidianamente le azioni delle aziende della difesa. I fondamentali di Rheinmetall sono eccezionali — portafoglio €50 mld, supporto NATO, margini record. Questo portale dà agli investitori retail accesso a rendimenti di livello istituzionale.',
    },
  },

  // Footer
  footer: {
    rights: '© {{year}} Rheinmetall AG. Tutti i diritti riservati.',
    disclaimer: 'Gli investimenti in titoli comportano rischi. Le performance passate non garantiscono risultati futuri.',
  },
};